<template>
  <div class="notfound">
    <div class="row first-row">
      <img src="/dist/site/static/icons/404_icon.svg" id="first-svg" alt="not found">
    </div>

    <p class="title">404</p>
    <p class="subtitle">Page not found</p>
    
    <div class="row second-row">
     <img src="/dist/site/static/icons/404.svg" id="second-svg" alt="not found">
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
};
</script>

<style lang="scss" scoped>
.notfound {
  text-align: center;

  .title {
    font-family: Circular Std;
    font-style: normal;
    font-weight: normal;
    font-size: 200px;
    line-height: 253px;
    text-align: center;
    color: #303133;
  }

  .subtitle {
    font-family: Circular Std;
    font-style: normal;
    font-weight: normal;
    font-size: 30px;
    line-height: 70px;
    color: #303133;
  }
}

  #first-svg {
    position: absolute; left: 0; top: 96px;
  }

  #second-svg {
    transform: rotate(200deg);
    position: absolute;
    top: 241px;
    right: -3%;
  }

.img-not-found {
  max-width: 200px;
}

.first-row {
  float: left;
}

.second-row {
  float: right;
}

@media screen and (max-width: 767px) {
  #first-svg, #second-svg {
    display: none !important;
  }
}
</style>